import { Basket, CommercetoolsBasket, GenericBasket, GenericBasketItem } from '@/types';
import { assertDefined } from '../assertDefined';
import { getParams } from '../params';
import { fetchFromApi } from './fetchFromApi';

export const fetchBasket = (basketId: string): Promise<GenericBasket> => {
  return getParams().useCommercetoolsBasket
    ? fetchCommercetoolsBasket(basketId)
    : fetchLegacyBasket(basketId);
};

export const fetchLegacyBasket = (basketId: string): Promise<GenericBasket> =>
  fetchFromApi<Basket>(`baskets/${basketId}`).then((apiBasket) => {
    const genericBasketItems: GenericBasketItem[] = apiBasket.basketItems.map((basketItem) => {
      return {
        id: basketItem.id,
        quantity: basketItem.quantity,
        shopId: basketItem.shop?.id,
        productId: basketItem.element.id,
        productTypeId: basketItem.element.properties.find((p) => p.key === 'productType')!.value,
        sizeId: basketItem.element.properties.find((p) => p.key === 'size')!.value,
      };
    });

    return {
      items: genericBasketItems,
      id: apiBasket.id,
    };
  });

export const fetchCommercetoolsBasket = (basketId: string): Promise<GenericBasket> =>
  fetchFromApi<CommercetoolsBasket>(`carts/${basketId}`).then((ctBasket) => {
    const genericBaskeItems: GenericBasketItem[] = ctBasket.lineItems.map((lineItem) => {
      return {
        id: lineItem.id,
        quantity: lineItem.quantity,
        shopId: lineItem.custom.fields.sprdShopId,
        productId: lineItem.custom.fields.sprdProductId,
        productTypeId: assertDefined(
          lineItem.variant.attributes.find((a) => a.name === 'sprdProductTypeId')
        ).value.toString(),
        sizeId: assertDefined(
          lineItem.variant.attributes.find((a) => a.name === 'sprdSizeId')
        ).value.toString(),
      };
    });

    return {
      items: genericBaskeItems,
      id: ctBasket.id,
    };
  });
